import type { WeddingSettings } from '@shared/settings'
import { useReveal } from '../../../ui/Cord'
import { cx, tieneTexto, urlSegura } from './comunes'

/* ===========================================================================
   El versículo — corazón espiritual de la página.

   Sin comillas decorativas ni ornamentos: el texto grande, la referencia
   pequeña debajo, y aire alrededor. Sobre palo santo si no hay foto de fondo;
   sobre la foto oscurecida si la hay.
   =========================================================================== */

export function hayVersiculo(verse: WeddingSettings['verse']): boolean {
  return tieneTexto(verse.text)
}

export default function Versiculo({ verse }: { verse: WeddingSettings['verse'] }) {
  const ref = useReveal<HTMLElement>()
  const fondo = urlSegura(verse.backgroundUrl)

  return (
    <section
      id="versiculo"
      ref={ref}
      data-nudo=""
      aria-label="Versículo"
      className={cx(
        'revelar relative isolate overflow-hidden px-5 py-10 sm:px-10 sm:py-14 lg:px-16 lg:py-16',
        fondo ? 'bg-tinta' : 'bg-palo',
      )}
    >
      {fondo && (
        <>
          <img
            src={fondo}
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="absolute inset-0 -z-10 h-full w-full object-cover"
          />
          <div aria-hidden="true" className="absolute inset-0 -z-10 bg-tinta/78" />
        </>
      )}

      {/* Centrado en el viewport y en el eje del texto: es la única sección
          que se lee como un respiro, no como un dato, y el aire simétrico es
          lo que la hace sentirse deliberada en una pantalla ancha. */}
      <blockquote className="mx-auto max-w-3xl text-center">
        <p
          className={cx(
            'font-display text-titulo leading-tight text-balance',
            fondo ? 'text-bruma' : 'text-tinta',
          )}
        >
          {verse.text}
        </p>
        {tieneTexto(verse.reference) && (
          <footer className={cx('eyebrow mt-6', fondo ? 'text-palo' : 'text-palo-hondo')}>
            {verse.reference}
          </footer>
        )}
      </blockquote>
    </section>
  )
}
